// extracted by mini-css-extract-plugin
export default {"avatarSelectWrapper":"IconForm_avatarSelectWrapper__pHInQ"};